import { Route } from 'src/routes/Route'

export const ActCheckoutRoute = Route({
  path: '/checkout/:cardId',
  init: (cardId: string) => ({ cardId }),
  fromPath: ({ cardId }) => (cardId ? { cardId } : undefined),
})
export type ActCheckoutRoute = Route<typeof ActCheckoutRoute>
